import React, {createContext, useState} from 'react';

interface TabSwitchContext {
  tabSwitch: boolean;
  setTabSwitch: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TabSwitchContext = createContext<TabSwitchContext>({
  tabSwitch: true,
  setTabSwitch: () => {},
});

export const TabSwitchProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [tabSwitch, setTabSwitch] = useState(false);

  return (
    <TabSwitchContext.Provider value={{tabSwitch, setTabSwitch}}>
      {children}
    </TabSwitchContext.Provider>
  );
};
